module.exports = __webpack_public_path__ + "media/images/products/blog-desktop-9cae2881dd4a107502a45ac182c3f11d.png";